import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import {
  fetchPricing,
  selectPricingConfig,
  getPlanWithLowestMonthlyPrice,
  setCoupon,
} from '../../store/pricingSlice'
import PartnerPage from 'js/pages/PartnerPage/PartnerPage'
import HowItWorks from 'js/components/HowItWorks/HowItWorks'
import SocialProof from 'js/components/SocialProof/SocialProof'
import Testimonials from 'js/components/Testimonials/Testimonials'
import FormattedCurrency from 'js/components/FormattedCurrency'
import Modal from 'js/components/Modal/Modal'
import Button from 'js/components/Button/Button'

import messages from './messages'
import WhatIsLifesum from '../../components/WhatIsLifesum/WhatIsLifesum'

function PricingInfo({ product, currency = 'USD' }) {
  if (!product) return null
  return (
    <div>
      <span className="strikethrough mr-8 type-32-demibold">
        <FormattedCurrency
          value={product.originalPrice}
          currency={currency}
          className=""
        />
      </span>
      <FormattedMessage
        {...messages.pricingInfo}
        values={{
          price: (
            <span className="font-demibold text-green">
              <FormattedCurrency value={product.price} currency={currency} />
            </span>
          ),
          pricePerMonth: (
            <FormattedCurrency
              value={product.pricePerMonth}
              currency={currency}
            />
          ),
        }}
      />
    </div>
  )
}

PricingInfo.propTypes = {
  product: PropTypes.object,
  currency: PropTypes.string,
}

const GEPage = () => {
  const [hasError, setHasError] = useState(false)
  const dispatch = useDispatch()
  const [bestPlan, setBestPlan] = useState()
  const config = useSelector(selectPricingConfig('GE-RDVH7Z'))

  useEffect(() => {
    if (config && config.products) {
      setBestPlan(getPlanWithLowestMonthlyPrice(config.products))
    }
  }, [config])

  useEffect(() => {
    dispatch(fetchPricing('GE-RDVH7Z', 'USD')).catch(() => setHasError(true))
    dispatch(setCoupon('GE-RDVH7Z'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const currentDate = new Date()
  const year =
    currentDate.getMonth() >= 11 // December
      ? currentDate.getFullYear() + 1
      : currentDate.getFullYear()

  return (
    <PartnerPage
      partner="ge"
      heroImage={require('./bg-ge.jpg')}
      heroHeading={<FormattedMessage {...messages.heroHeading} />}
      heroSubHeading={<FormattedMessage {...messages.heroSubHeading} />}
      heroMessage={null}
      ctaButton={
        <Link
          data-uid="claim_offer_button"
          className="c-button c-button--premium"
          to={`account`}
        >
          <span>
            <FormattedMessage {...messages.ctaButtonText} />
          </span>
        </Link>
      }
      rootUrl={'/ge'}
      transparentHeader={true}
      redeemCode="GE-RDVH7Z"
    >
      <div
        className="mx-auto mb-72 mt-40 max-w-1024 text-left lg:text-center"
        id="start"
      >
        <div className="mx-24 lg:mx-auto lg:w-4/5">
          <div className="leading-body type-24 lg:mx-48">
            {bestPlan && <PricingInfo product={bestPlan} />}
            <p className="mb-24 py-64">
              <FormattedMessage {...messages.introText} values={{ year }} />
            </p>
            <p>
              <FormattedMessage {...messages.callOut} />
            </p>
          </div>
        </div>
      </div>
      <div className="pb-24 text-left lg:pb-48 lg:text-center">
        <div className="mx-auto px-20 lg:px-32">
          <h2 className="mb-24 type-40 lg:mb-36 lg:type-56">
            <FormattedMessage {...messages.howToHeading} />
          </h2>
          <HowItWorks />
        </div>
      </div>
      <div className="bg-Bg pb-24 pt-40 text-center lg:pt-56">
        <div className="o-width-limiter">
          <h2 className="mb-24 type-40 lg:mb-36 lg:type-56">
            <FormattedMessage {...messages.whatsIncludedHeading} />
          </h2>
          <br />
          <WhatIsLifesum />
        </div>
      </div>
      <div>
        <SocialProof />
        <div className="o-width-limiter o-width-limiter--mid">
          <div className="mx-auto px-20 lg:max-w-[80%] lg:px-0">
            <Testimonials />
          </div>
        </div>
        <div className="o-width-limiter">
          <div className="mb-192 mt-40 text-center md:mt-64 lg:mt-96">
            <div className="c-premium-button">
              <Link
                className="c-button c-premium-button__cta c-premium-button__cta--signup c-button--premium"
                to="account"
              >
                <span>
                  <FormattedMessage {...messages.ctaButtonText} />
                </span>
              </Link>
            </div>
            {<PricingInfo product={bestPlan} />}
          </div>
        </div>
      </div>
      {hasError && (
        <Modal onClose={() => window.location.reload()}>
          <FormattedMessage {...messages.errorMessage} />
          <div className="mt-16">
            <Button onClick={() => window.location.reload()}>
              <FormattedMessage {...messages.tryAgain} />{' '}
            </Button>
          </div>
        </Modal>
      )}
    </PartnerPage>
  )
}

GEPage.propTypes = {
  bestPlan: PropTypes.object,
  fetchPricing: PropTypes.func,
  setCoupon: PropTypes.func,
}

export default GEPage
